import React from 'react'
import { useS4LContext } from '@s4l/react-context'
import { PriceContext } from '..'
import { Typography } from '@s4l/ds'
import TotalNights from '../TotalNights'

export const PricePerNight = () => {
  const { price } = React.useContext(PriceContext)
  const { i18n } = useS4LContext()

  const isFeatured = price.isFeaturedPrice('perNight')

  const big = {
    variant: 'title',
    size: 'xs',
  } as const

  const small = {
    variant: 'caption',
    size: 'm',
  } as const

  const props = isFeatured ? big : small

  const color = isFeatured ? 'var(--color-neutral-900)' : 'var(--color-neutral-800)'

  return (
    <Typography color={color} variant="caption" size="m" bold={!isFeatured}>
      {i18n.formatMessage(
        { id: 'global.price-night' },
        {
          price: (
            <Typography color={color} bold={!isFeatured} {...props}>
              {price.getFormatted(i18n.locale, 'perNight')}
            </Typography>
          ),
        }
      )}
      <TotalNights show={!isFeatured} />
    </Typography>
  )
}
